import { combineReducers } from "@reduxjs/toolkit";
import UserSlice from "./userSlice";
import SubscriptionSlice from "./subscription"



const Slices = combineReducers({
  User: UserSlice,
  Subscription: SubscriptionSlice,
});
export default Slices;
